import WrapperService from "@/modules/core/services/wrapper-service";
import { createPageableParams } from "@/modules/core/services/table-utils";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/facility/contract"

const tableFields = ["translatedType", "checkbox"];
const databaseFields = ["", ""];

const serviceName = "ContractInfo-Service: ";

export default class ContractInfoService {

  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id, null, serviceName, successF, errorF);
  }

  static async readContract(id, successF, errorF){
    await WrapperService.get(API_URL + "/read/" + id, null, serviceName, successF, errorF);
  }

  static async readAllPaginatedFromAPI(facilityId, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page,size,search,sort,sortAsc,tableFields,databaseFields)
    await WrapperService.get(API_URL + "/" + facilityId, {params:params}, "ContractInfo-Service: ", successF, errorF);
  }

  static async readAllByCustomerPaginatedFromAPI(page, size, search, sort, sortAsc, filter, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, tableFields, databaseFields);
    if (filter && filter.customer) {
      params.append('customer', filter.customer);
    }
    await WrapperService.get(API_URL + '/global', {params:params}, "ContractInfo-Service: ", successF, errorF);
  }

  static putToAPI(facilityId, info, successF, errorF) {
    WrapperService.put(API_URL + "/" + facilityId, info, serviceName, successF, errorF);
  }

  static deleteFromAPI(info, successF, errorF) {
    WrapperService.delete(API_URL + "/" + info, null, serviceName, successF, errorF);
  }

  static async readRequiredContractsForFacilityFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + '/facility/' + id + '/score', null, serviceName, successF, errorF);
  }

  static async readContractByFacility(id, successF, errorF){
    await WrapperService.get(API_URL + '/facility/' + id + '/info', null, serviceName, successF, errorF)
  }
}
